<!--赖传峰-->
<!--2023/5/26-->
<script lang="ts" setup>
import { computed, defineAsyncComponent, isPikPakClient, onBeforeMount } from '#imports'
import { useMediaQuery } from '@vueuse/core'
import { useLayout } from '~/store/layout'

const AsyncMobileHeader = defineAsyncComponent({ loader: () => import('./MobileHeader.vue') })
const AsyncPCHeader = defineAsyncComponent({ loader: () => import('./PCHeader.vue') })
const isNarrowScreen = useMediaQuery('(max-width: 1024px)')
const layout = useLayout()
const isMobile = computed(() => isNarrowScreen.value || layout.isMobile)

const isPikPak = computed(() => isPikPakClient())
onBeforeMount(() => {
  if (isPikPak.value) {
    document.documentElement.style.setProperty('--header-height', '0px')
  }
})
</script>

<template>
  <ClientOnly>
    <div>
      <LangChange />
      <template v-if="!isPikPak">
        <AsyncMobileHeader v-if="isMobile" />
        <AsyncPCHeader v-else />
      </template>
    </div>
  </ClientOnly>
</template>
